module.exports = __webpack_public_path__ + "img/tanker_stopped.03a25b40.svg";